import _ from '../helper/HelperFunctions'

export default class ContentCalendar {
	constructor(el) {
		this.el = el;
		this.scrollingContainer = this.el.querySelector('.content-calendar__wrapper');
		this.scrollingContainerWidth = this.scrollingContainer.offsetWidth;
		this.shadowContainer = this.el.querySelector('.content-calendar__shadow');
		this.arrowContainer = this.el.querySelector('.content-calendar__arr');
		this.columns = this.el.querySelectorAll('.content-calendar__column');

		this.addEventListeners();

		this.activateMonths();

		this.checkPosition(false);

		/* Fix on time of release.. */
		setTimeout(function() {
			if (this.checkIfMobile()) {
				this.setContainerHeight(true, false);
			}
		}.bind(this), 500)
	}

	addEventListeners() {
		/* Scrolling event for the Content Calendar */
		this.scrollingContainer.addEventListener('scroll', _.throttle(this.checkPosition.bind(this), 100))

		window.addEventListener('resize', _.debounce(() => {
			this.activateMonths(this.getActiveMonths())
		}, 100))

		/* Clicking event for the arrows */
		this.arrowContainer.querySelector('.content-calendar__arr--left').addEventListener(_.clickEvent(), e => {
			e.preventDefault();

			this.previousMonth(this.getActiveMonths())
		})
		this.arrowContainer.querySelector('.content-calendar__arr--right').addEventListener(_.clickEvent(), e => {
			e.preventDefault();

			this.nextMonth(this.getActiveMonths());
		})
	}

	checkIfMobile() {
		if (window.innerWidth <= 480) {
			return true;
		} else {
			return false;
		}
	}

	/**
	 * 
	 * @param {Boolean} bool Whether to set the container to a number of px (the highest column -> true) or to auto (false). Is true by default.
	 * @param {Boolean} scroll Whether to scroll to the top of the content calendar or not. Defaults to true.
	 */
	setContainerHeight(bool = true, scroll = true) {
		if (bool) {
			let columns = _.toArray(this.el.querySelectorAll('.content-calendar__column.active'));
			let highestColumn = 0;

			columns.forEach(col => {
				let innerHeight = 0;

				innerHeight += col.querySelector('.content-calendar__month').offsetHeight;
				innerHeight += col.querySelector('.content-calendar__shows').offsetHeight;

				if (highestColumn < innerHeight) {
					highestColumn = innerHeight
				}
			})

			this.scrollingContainer.style.maxHeight = highestColumn + 30 + 'px';
			if (scroll) {
				_.scrollTo('.content-calendar.module', 200);
			}
		} else {
			this.scrollingContainer.style.maxHeight = 'none';
		}
	}

	/**
	 * 
	 * @param {Boolean} bool whether to check set container height.
	 */
	checkPosition(bool = true) {

		// Check scroll positions
		if (this.checkIfMobile()) {
			for (let i = 0; i < this.columns.length; i++) {
				if (this.columns[i].getBoundingClientRect().left < 30 && this.columns[i].getBoundingClientRect().left > -290 && !this.columns[i].classList.contains('active')) {
					_.removeClassFromAll(this.columns, 'active', this.columns[i], true);

					if (bool) {
						if (this.checkIfMobile()) {
							this.setContainerHeight();
						} else {
							this.setContainerHeight(false);
						}
					}
				}
			}
		}

		// Enable navigiation
		var active = this.getActiveMonths()
		var keys = Object.keys(active)

		var first = active[keys[0]]
		var last = active[keys[keys.length - 1]]


		this.enableLeft(!!first.previousSibling)
		this.enableRight(!!last.nextSibling)
	}

	/**
	 * 
	 * @param {Boolean} bool whether to enable or disable the left arrow & shadow.
	 */
	enableLeft(bool) {
		if (bool) {
			this.shadowContainer.classList.add('left');
			this.arrowContainer.classList.add('left');
		} else {
			this.shadowContainer.classList.remove('left');
			this.arrowContainer.classList.remove('left');
		}
	}

	/**
	 * 
	 * @param {Boolean} bool whether to enable or disable the right arrow & shadow.
	 */
	enableRight(bool) {
		if (bool) {
			this.shadowContainer.classList.add('right');
			this.arrowContainer.classList.add('right');
		} else {
			this.shadowContainer.classList.remove('right');
			this.arrowContainer.classList.remove('right');
		}
	}

	getActiveMonths() {
		let activeMonths = [];
		for (let i = 0; i < this.columns.length; i++) {
			if (this.columns[i].classList.contains('active')) {
				activeMonths.push(this.columns[i]);
			}
		}

		return activeMonths;
	}

	getCurrentMonth() {
		let currentMonth = parseInt(new Date().getMonth());
		let currentColumn = _.parents(document.querySelector(`a[data-month="${currentMonth}"]`), '.content-calendar__column');

		let columns = [currentColumn];


		return columns;
	}

	/**
	 * 
	 * @param {Array} columns the columns (months) that need to be activated. This is an empty array if there are no columns active yet. Then we will activate the first columns.
	 * @param {Boolean} mobile per default this is false. If it's true, we only want one column to be active at a time.
	 */
	activateMonths(columns) {
		_.removeClassFromAll(this.columns, 'active');


		if (columns && columns.length) {
			for (let i = 0; i < columns.length; i++) {
				columns[i].classList.add('active');
			}

			this.scrollToMonth(columns[0]);
		} else {

			var active = this.el.querySelector('.content-calendar__column.current')

			if (!active) {
				active = this.columns[0]
			}

			/* If initializing there's no columns active so we activate the first two. */
			active.classList.add('active');
			if (!this.checkIfMobile()) {
				if (active.nextSibling) {
					active.nextSibling.classList.add('active');
				} else if (active.previousSibling) {
					active.previousSibling.classList.add('active');
				}
			}

			this.scrollToMonth(this.getActiveMonths()[0], false)
		}
	}

	/**
	 * 
	 * @param {Node} column the column (month) we scroll to because it got activated.
	 * @param bool animate Indicate wether to animate the scroll interaction
	 */
	scrollToMonth(column, animate) {
		let containerLeftValue;
		let offsetPosition;
		let targetPosition;
		if (!this.checkIfMobile()) {
			containerLeftValue = this.scrollingContainer.getBoundingClientRect().left;
			offsetPosition = this.scrollingContainer.scrollLeft;
			targetPosition = column.getBoundingClientRect().left + offsetPosition - 32;

			if (column === this.columns[this.columns.length - 2]) {
				targetPosition = column.getBoundingClientRect().left + offsetPosition;
			}
		} else {
			containerLeftValue = this.scrollingContainer.getBoundingClientRect().left;
			offsetPosition = this.scrollingContainer.scrollLeft;
			targetPosition = column.getBoundingClientRect().left + offsetPosition;
		}

		if (typeof animate != 'undefined' && !animate) {
			this.scrollingContainer.scrollLeft = targetPosition

			return;
		}

		// Animate scroll
		let startPosition = offsetPosition;
		let distance = (targetPosition - startPosition) - containerLeftValue;
		let startTime = null;
		let duration = 600;

		const animation = (currentTime) => {
			if (startTime === null) {
				startTime = currentTime;
			}

			let timeElapsed = currentTime - startTime;
			let run = ease(timeElapsed, startPosition, distance, duration);
			this.scrollingContainer.scrollTo(run, 0);
			if (timeElapsed < duration) {
				requestAnimationFrame(animation);
			}
		}

		const ease = (t, b, c, d) => {
			t /= d / 2;
			if (t < 1) {
				return c / 2 * t * t * t + b;
			}
			t -= 2;
			return c / 2 * (t * t * t + 2) + b;
		};

		requestAnimationFrame(animation);
	}

	/**
	 * 
	 * @param {Array} activeMonth we receive the columns (months) that are currently active. Based off of that we select and activate the next months, IF there are some.
	 */
	nextMonth(activeMonths) {
		if (!this.checkIfMobile()) {
			if (activeMonths[1].nextSibling) {
				this.activateMonths([activeMonths[1], activeMonths[1].nextSibling]);
			}
		} else {
			if (activeMonths[0].nextSibling) {
				this.activateMonths([activeMonths[0].nextSibling]);
			}
		}
	}

	/**
	 * 
	 * @param {Array} activeMonth we receive the columns (months) that are currently active. Based off of that we select and activate the previous months, IF there are some.
	 */
	previousMonth(activeMonths) {
		if (!this.checkIfMobile()) {
			if (activeMonths[0].previousSibling) {
				this.activateMonths([activeMonths[0].previousSibling, activeMonths[0]]);
			}
		} else {
			if (activeMonths[0].previousSibling) {
				this.activateMonths([activeMonths[0].previousSibling]);
			}
		}
	}
}